angular.module('unergie.main')
.controller('tinyUrlsCtrl', ($scope, $state, ApiUser, DataAccess, DataAccessSearch, MS, AlertManager, EnvUtils,
    TableGeneratorService, ModalService, ReferencesService, DownloadService, ErrorCatcher) => {
    $scope.newUrl = ''
    $scope.prefix = `${EnvUtils.frontUrl}/s/`

    $scope.tinyUrls = {
        refreshing: false,
        show: {},
        counts: [10, 25, 50, 100],
        columns: {
            id: { label: 'Id', mode: 'search_wildcard' },
            key: { label: 'Key', mode: 'hidden' },
            url: { label: 'URL destination', mode: 'search_wildcard' },
            creation_ts: { label: 'Création', mode: 'search_date' },
        },
    }

    $scope.modifyTemplate = {
        url: '',
    }

    $scope.modifyFields = {
        url: {
            label: `Nouvelle Url`,
            type: 'text',
        },
    }

    $scope.deleteFields = {
        label: {
            label: `<span class="red"><span class="fa fa-warning"></span> Attention : assurez-vous que le lien n'a pas été diffusé, il sera inopérant après sa suppression</span>`,
            type: 'label',
        },
    }

    $scope.createTinyUrl = (tinyUrl) => {
        $scope.creating = true
        return DataAccess.createTinyUrl({ url: $scope.newUrl }).$promise.then((result) => {
            // eslint-disable-next-line no-undef
            navigator.clipboard.writeText(result.url)
            AlertManager.success('Tiny URL créée et copiée dans le presse papier !')
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.creating = false
        })
    }

    $scope.modifyUrl = (tinyUrl) => {
        tinyUrl.modifying = true
        return DataAccess.modifyTinyUrl({ id: tinyUrl.id }, { url: $scope.modifyTemplate.url }).$promise.then((result) => {
            $scope.modifyTemplate.url = ''
            AlertManager.success('Tiny URL modifiée !')
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            tinyUrl.modifying = false
        })
    }

    $scope.deleteUrl = (tinyUrl) => {
        tinyUrl.deleting = true
        return DataAccess.deleteTinyUrl({ id: tinyUrl.id }).$promise.then((result) => {
            AlertManager.success('Tiny URL supprimée !')
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            tinyUrl.deleting = false
        })
    }

    const activate = () => {
        TableGeneratorService.getTable($scope.tinyUrls, 'tiny-urls', null, null, { orderBy: '-creation_ts' })
    }

    $scope.refresh = activate
    activate()
})
